const STATUS_COPY = {
  cached: {
    eyebrow: 'SAVED PROGRESS',
    title: 'Your Home is ready.',
    body: 'Checking for the latest logs in the background.',
  },
  refreshing: {
    eyebrow: 'UPDATING',
    title: 'Showing your saved progress.',
    body: 'Latest logs are loading in the background.',
  },
  loading: {
    eyebrow: 'HOME',
    title: 'Loading today’s progress…',
    body: 'This is taking a moment. You can still use the navigation below.',
  },
  offline: {
    eyebrow: 'OFFLINE',
    title: 'You’re looking at saved progress.',
    body: 'Reconnect, then retry to pull in your latest logs.',
  },
  timeout: {
    eyebrow: 'STILL WAITING',
    title: 'Home couldn’t refresh in time.',
    body: 'Your connection may be slow. Retry when you’re ready.',
  },
  error: {
    eyebrow: 'REFRESH NEEDED',
    title: 'Home couldn’t load the latest data.',
    body: 'Nothing was changed. Retry to check again.',
  },
};

export default function HomeDataStatus({
  hasSnapshot = false,
  retry,
  status,
}) {
  if (!status || status === 'ready') return null;
  const copy = STATUS_COPY[status] || STATUS_COPY.loading;
  const canRetry = ['offline', 'timeout', 'error'].includes(status);
  const prominent = !hasSnapshot;

  return (
    <section
      aria-live="polite"
      aria-label="Home data status"
      style={{
        padding: prominent
          ? 'calc(var(--space-12) + env(safe-area-inset-top)) var(--screen-x) var(--space-8)'
          : '0 var(--screen-x) var(--space-4)',
      }}
    >
      <div style={{
        alignItems: 'center',
        background: 'var(--surface)',
        border: '1px solid var(--card-border)',
        borderRadius: 'var(--radius-card)',
        boxShadow: 'var(--shadow-card)',
        display: 'flex',
        gap: 'var(--space-4)',
        justifyContent: 'space-between',
        minHeight: prominent ? 132 : 0,
        padding: prominent ? 'var(--space-6)' : 'var(--space-4)',
      }}>
        <div style={{ minWidth: 0 }}>
          <p style={{
            color: 'var(--muted-strong)',
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: 1.1,
            margin: '0 0 var(--space-1)',
          }}>
            {copy.eyebrow}
          </p>
          <p style={{
            color: 'var(--text)',
            fontFamily: 'var(--font-display)',
            fontSize: prominent ? 19 : 14,
            fontWeight: 700,
            lineHeight: 1.15,
            margin: 0,
            overflowWrap: 'anywhere',
          }}>
            {copy.title}
          </p>
          <p style={{
            color: 'var(--text-soft)',
            fontSize: 12,
            lineHeight: 1.4,
            margin: 'var(--space-2) 0 0',
          }}>
            {copy.body}
          </p>
        </div>
        {canRetry ? (
          <button
            onClick={() => retry?.()}
            style={{
              background: 'var(--surface-strong)',
              border: '1px solid var(--card-border-strong)',
              borderRadius: 'var(--radius-md)',
              color: 'var(--brand-coral)',
              cursor: 'pointer',
              flexShrink: 0,
              fontFamily: 'var(--font-body)',
              fontSize: 12,
              fontWeight: 700,
              minHeight: 48,
              padding: '0 var(--space-4)',
            }}
            type="button"
          >
            Retry
          </button>
        ) : (
          <span aria-hidden="true" style={{ fontSize: 22, flexShrink: 0 }}>
            {prominent ? '🏃' : '↻'}
          </span>
        )}
      </div>
    </section>
  );
}
